import React from "react";
import { ImageOff } from "lucide-react";
import { Checkbox } from "@/components/ui/checkbox";
import { AuthImage } from "./AuthImage";
import { ConformityBadge } from "./ConformityBadge";
import { swatchImageUrl } from "./useFabricLibrary";

const Caption = ({ children }) => <span className="block text-[10px] font-semibold uppercase tracking-wider text-zinc-500 mt-1">{children}</span>;

export function FabricReviewRow({ idx, row, refs, swatch, onChange }) {
  const setKey = (key) => onChange({ key: key || null, attach: !!key, addToLibrary: !!key, replace: false });
  return (
    <div className="grid grid-cols-[132px_132px_1fr] gap-4 p-3 rounded-lg border border-zinc-200 bg-white" data-testid={`fabric-review-row-${idx}`}>
      <figure>
        <img src={row.src} alt={row.filename || "Image email"} referrerPolicy="no-referrer" className="w-[132px] h-[82px] object-cover rounded-md border border-zinc-300 bg-zinc-100" />
        <Caption>Email de commande</Caption>
      </figure>
      <figure>
        {swatch ? (
          <AuthImage src={swatchImageUrl(swatch)} alt="Bibliothèque" className="w-[132px] h-[82px] object-cover rounded-md border border-zinc-300" />
        ) : (
          <div className="w-[132px] h-[82px] rounded-md border-2 border-dashed border-zinc-300 flex flex-col items-center justify-center text-zinc-400 text-center px-2">
            <ImageOff className="w-4 h-4 mb-1" /><span className="text-[10px] leading-tight">{row.key ? "Pas encore en bibliothèque" : "—"}</span>
          </div>
        )}
        <Caption>Bibliothèque</Caption>
      </figure>
      <div className="space-y-2 min-w-0">
        <div className="flex items-center gap-2 flex-wrap">
          <select value={row.key || ""} onChange={(e) => setKey(e.target.value)} className="h-8 px-2 text-sm border border-zinc-300 rounded-md bg-white max-w-full focus:outline-none focus:ring-2 focus:ring-orange-400" data-testid={`fabric-review-select-${idx}`}>
            <option value="">Non associée à une toile</option>
            {refs.map((r) => <option key={r.key} value={r.key}>{r.label}{r.count > 1 ? ` (×${r.count})` : ""}</option>)}
          </select>
          <ConformityBadge swatch={swatch} src={row.src} testId={`fabric-review-conformity-${idx}`} />
        </div>
        <label className="flex items-center gap-2 text-sm text-zinc-700 cursor-pointer">
          <Checkbox checked={row.attach} onCheckedChange={(v) => onChange({ attach: !!v })} data-testid={`fabric-review-attach-${idx}`} />
          Joindre à la commande (imprimée avec la fiche)
        </label>
        {row.key && (swatch ? (
          <label className="flex items-center gap-2 text-sm text-zinc-700 cursor-pointer">
            <Checkbox checked={row.replace} onCheckedChange={(v) => onChange({ replace: !!v })} data-testid={`fabric-review-replace-${idx}`} />
            Remplacer la photo de la bibliothèque
          </label>
        ) : (
          <label className="flex items-center gap-2 text-sm text-zinc-700 cursor-pointer">
            <Checkbox checked={row.addToLibrary} onCheckedChange={(v) => onChange({ addToLibrary: !!v })} data-testid={`fabric-review-library-${idx}`} />
            Ajouter à la bibliothèque
          </label>
        ))}
      </div>
    </div>
  );
}
